import classes from "./Spinner.module.scss";

const Spinner = ({ className = "", ...props }) => {
  return <span className={`${classes.loader} ${className}`} {...props}></span>;
};

export default Spinner;
